import { Placeholders } from '../../../types/models/placeholders/placeholders.types';
import { PLACEHOLDERS_ENDPOINTS } from '../../../utils/api/endpoints/placeholdersEndpoints';

const PREFIX = '[placeholdersQuery]';

export const placeholdersQuery = async (names: string[]) => {
  console.log(PREFIX, `Fetching placeholders infos...`);
  const response = await PLACEHOLDERS_ENDPOINTS.getMultiple(names);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received placeholders infos.`);
  return json as Placeholders[];
};
